import * as actionTypes from "./actionTypes";

export const get_transactions = (payload)=>{
    return {
        type: actionTypes.GET_TRANSACTIONS,
        payload: payload
    }
}